var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUphill3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 124,
    height: 52,
    viewBox: "0 0 124 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.4863 24.7864L4.5 24.6435V24.5V22.2761C4.5 14.0051 14.1537 9.49407 20.4982 14.8003C25.4109 18.9092 32.3229 19.633 37.9802 16.6311L50.1513 10.1731C52.4325 8.9626 55.1186 8.77119 57.5485 9.64592L69.8402 14.071C75.4067 16.0749 81.0479 11.283 79.9706 5.4657C79.7813 4.44339 80.566 3.5 81.6057 3.5H110.225C114.434 3.5 118.157 6.23205 119.419 10.2479L119.722 11.2125C120.78 14.5794 119.574 18.246 116.723 20.3264L111.338 24.2558C106.416 27.8473 106.291 35.1476 111.086 38.9062C113.342 40.6745 112.298 44.29 109.446 44.5831L74.6385 48.1615C73.4097 48.2879 72.1931 47.8279 71.3552 46.9202C68.2771 43.5855 63.3288 42.7642 59.3384 44.9257L55.8022 46.8412C53.986 47.8249 51.8892 48.1611 49.8566 47.7946L28.1059 43.8724C24.4424 43.2117 20.6636 43.9033 17.4715 45.8185C10.8792 49.7739 2.59177 44.5436 3.3256 36.8908L4.4863 24.7864Z",
    stroke: "currentColor",
    strokeWidth: 6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUphill3);
export default __webpack_public_path__ + "static/media/uphill3.c855386c.svg";
export { ForwardRef as ReactComponent };